import { isVideoFile } from '../helpers/file-type'
import { PLANS } from '../constants/plans'

export const checkVideoFilesAndSetPreview = (site, files, userProfile) => {
  const proPlanIds = [PLANS.PRO_U.id, PLANS.PRO_MAX.id]
  const isProUser = proPlanIds.includes(userProfile.productId)
  const shouldShowPreview = !isProUser

  if (shouldShowPreview && files && files.length > 0) {
    if (hasVideoFiles(files) && filesUnder75MB(files)) {
      site.inPreviewMode = true
      site.linkPreviewType = 'VIDEO_FILE'
    }
  }
  return site
}

export const filesUnder75MB = (files) => {
  if (!files || files.length === 0) return false

  return files.some((file) => isVideoFile(file.name, file.type) && file.size <= 75 * 1024 * 1024)
}

export const hasVideoFiles = (files) => {
  if (!files || files.length === 0) return false

  return files.some((file) => isVideoFile(file.name, file.type))
}
